// frontend/src/components/common/PrivateRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loader from './Loader';

interface PrivateRouteProps {
  children: React.ReactElement;
  requireVerification?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requireVerification = true
}) => {
  const { currentUser, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  console.log('PrivateRoute - Auth State:', {
    isAuthenticated,
    currentUser: currentUser ? {
      ...currentUser,
      isVerified: currentUser.isVerified
    } : null,
    path: location.pathname,
    requireVerification
  });

  if (loading) {
    return (
      <div className="min-h-screen flex justify-center items-center">
        <Loader size="lg" />
      </div>
    );
  }

  if (!isAuthenticated || !currentUser) {
    console.log('PrivateRoute - Not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (
    requireVerification &&
    !currentUser.isVerified &&
    location.pathname !== '/verification-required'
  ) {
    console.log('PrivateRoute - User not verified, redirecting to verification page');
    return (
      <Navigate
        to="/verification-required"
        state={{ email: currentUser.email, from: location }}
        replace
      />
    );
  }

  console.log('PrivateRoute - Rendering children (admin page)', { path: location.pathname });
  return children;
};

export default PrivateRoute;